module.exports = __webpack_public_path__ + "img/ic_item_ky_click.444f2e72.png";